<template>
  <div v-if="isLoaded && tableData && tableData.length" class="concert-content">
    <!-- <h2 class="title">
      {{ $t('CONCERT.LATEST') }}
    </h2> -->
    <div class="mk-table mk-table-concert-list" :class="{'loaded': isLoaded}">
      <div class="table-th table-tr">
        <div class="table-td td_40">
          {{ $t('CONCERT.PERFORMANCE_TITLE') }}
        </div>
        <div class="table-td td_30">
          {{ $t('CONCERT.PERFORMANCE_TIME') }}
        </div>
        <div class="table-td td_30">
          {{ $t('CONCERT.PERFORMANCE_VENUE') }}
        </div>
      </div>
      <RouterLink
        v-for="event in tableData"
        :key="event.event_id"
        :to="{ name:'eventById', params: { locale: $i18n.localePath(), id: event.id } }"
        class="table-tr"
      >
        <div class="table-td title">
          {{ event.title }}
        </div>
        <div class="table-td date">
          {{ event.venue && event.venue.datetime }}
        </div>
        <div class="table-td location">
          {{ event.venue && event.venue.name }}
        </div>
      </RouterLink>
    </div>
    <div v-if="isLoadMore" class="container--loader" style="padding-top: 0px; min-height: 140px;">
      <Loader :loading="isLoadMore" />
    </div>
  </div>
  <div v-else-if="isLoaded" class="concert-content">
    <NotResultDummy :message="$t('DUMMY.NOT_RESULT')" />
  </div>
  <div v-else class="container--loader">
    <Loader :loading="!isLoaded" />
  </div>
</template>

<script>
import Loader from '@/components/common/Loader'
import NotResultDummy from '@/components/common/DummyStatus/NotResultDummy'

export default {
  name: 'ConcertContent',
  components: {
    Loader,
    NotResultDummy
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    isLoaded: {
      type: Boolean,
      default: false
    },
    isLoadMore: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  created() {},
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/component/table.scss';

.concert-content {
  margin: 24px auto 0;
  max-width: 1440px;
  padding: 0 100px;
  .mk-table {
    opacity: 0;
    transition: .6s;
    margin-bottom: 40px;
    .table-tr .table-td {
      vertical-align: middle;
    }
    &.loaded{
      opacity: 1;
    }
  }
  > .title {
    font-size: 24px;
    font-weight: 500;
    line-height: 1.63;
    color: $grey-50;
    margin: 0 0 24px;
  }
  .item {
    display: inline-block;
  }
}
.container--loader {
  display: block;
  min-height: 200px;
  padding-top: 66px;
  // margin: 66px auto 24px;
  text-align: center;
}

@media only screen and (max-width: 1023.98px) {
  .concert-content {
    margin: 24px auto 0;
    padding: 0 36px;
    > .title {
      font-size: 20px;
      margin-bottom: 16px;
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .concert-content {
    padding: 0 24px;
  }
}
</style>
